<template>
    <div>
        <section class="breadcrumb__area breadcrumb__bg">
                    <div class="bg-img position-absolute top-0 bottom-0 start-0 w-100 h-100 kantor-bg"></div>
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="breadcrumb__content">
                                    <h2 class="title">{{$route.name}}</h2>
                                    <nav aria-label="breadcrumb">
                                        <ol class="breadcrumb">
                                            <li class="breadcrumb-item"><a href="javascript:void(0);">Layanan</a></li>
                                            <li class="breadcrumb-item active" aria-current="page">{{$route.name}}</li>
                                        </ol>
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="breadcrumb__shape">
                        <img src="assets/img/images/breadcrumb_shape01.png" alt="Apexa" class="dark-opacity" />
                        <img src="assets/img/images/breadcrumb_shape02.png" alt="Apexa" class="rightToLeft dark-opacity" />
                        <img src="assets/img/images/breadcrumb_shape03.png" alt="Apexa" class="dark-opacity" />
                        <img src="assets/img/images/breadcrumb_shape04.png" alt="Apexa" class="dark-opacity" />
                        <img src="assets/img/images/breadcrumb_shape05.png" alt="Apexa" class="alltuchtopdown dark-opacity" />
                    </div>
                </section>

        <section class="services__details-area">
            <div class="container">
                <div class="services__details-wrap">
                    <div class="row">
                        <div class="services__details-content">
                            <div class="services__details-list">
                                <div class="row">
                                    <div class="col-70" >
                                        <div v-for="(data) in list_data" :key="data.id">

                                        
                                        <a class="shine-animate" @click="push_data(data.id)" href="javascript:void(0);" :title="data.judul" >
                                        <div class="services__details-list-box">
                                                <div class="icon">
                                                <i class="far fa-file-pdf"></i>
                                                </div>
                                                <div class="content">
                                                    <p>
                                                            <i class="fas fa-calendar-alt" ></i>
                                                            <!-- {{ console.log('CEK DATA:', data) }} -->
                                                            {{ convert_tgl(data.createAt) }}
                                                            </p>
                                                    <h4 class="title" v-html="data.judul"></h4>
                                                    <p v-html="data.deskripsi"></p>
                                                </div>
                                            </div>
                                        </a>
                                       
                                        
                                    </div>
                                    <div class="pagination-wrap mt-40">
                                        <nav aria-label="Page navigation example">
                                            <ul class="pagination list-wrap">
                                                <li class="page-item"><a @click="btn_prev" class="page-link" href="javascript:void(0);"><i class="fas fa-angle-double-left"></i></a></li>
                                                <li class="page-item active"><a class="page-link" href="#">{{page_first}} - {{page_last}}</a></li>
                                                <li class="page-item next-page"><a class="page-link" @click="btn_next" href="javascript:void(0);"><i class="fas fa-angle-double-right"></i></a>
                                                </li>
                                            </ul>
                                        </nav>
                                    </div>
                                    </div>
                                    

                                  <!-- ===== SIDEBAR ======== -->
                    <div class="col-30">
                        <aside class="blog__sidebar">
                            <div class="sidebar__widget sidebar__widget-two">
                                <div class="sidebar__search">
                                    <form @submit.prevent>
                                        <input type="text" placeholder="Cari Data . . ." name="search" id="wid-search" value="" v-model="cari_value" @keyup="cari_data()" @keyup.enter.prevent="cari_data">
                                        <button type="submit">
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">
                                                <path d="M19.0002 19.0002L14.6572 14.6572M14.6572 14.6572C15.4001 13.9143 15.9894 13.0324 16.3914 12.0618C16.7935 11.0911 17.0004 10.0508 17.0004 9.00021C17.0004 7.9496 16.7935 6.90929 16.3914 5.93866C15.9894 4.96803 15.4001 4.08609 14.6572 3.34321C13.9143 2.60032 13.0324 2.01103 12.0618 1.60898C11.0911 1.20693 10.0508 1 9.00021 1C7.9496 1 6.90929 1.20693 5.93866 1.60898C4.96803 2.01103 4.08609 2.60032 3.34321 3.34321C1.84288 4.84354 1 6.87842 1 9.00021C1 11.122 1.84288 13.1569 3.34321 14.6572C4.84354 16.1575 6.87842 17.0004 9.00021 17.0004C11.122 17.0004 13.1569 16.1575 14.6572 14.6572Z" stroke="currentcolor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>
                                        </button>
                                    </form>
                                </div>
                            </div>
  
                            <div class="sidebar__widget">
                                <h4 class="sidebar__widget-title">Berita Terbaru</h4>
                                <div class="sidebar__post-list">
                                    <div class="sidebar__post-item" v-for="data in list_berita" :key="data.id">
                                        <div class="sidebar__post-thumb">
                                            <a class="shine-animate" @click="push_berita(data.id)" href="javascript:void(0);" :title="data.judul"><img :src="file_path+data.foto" alt="" height="80px"></a>
                                        </div>
                                        <div class="sidebar__post-content textbatas">
                                            <h5 class="title"><a class="shine-animate" @click="push_berita(data.id)" href="javascript:void(0);" :title="data.judul">{{ truncateText(data.judul, 50) }}</a></h5>
                                            <span class="date"><i class="flaticon-time"></i>{{convert_tgl(data.createAt)}}</span>
                                        </div>
                                      </div>
                                </div>
                            </div>
                            
                        </aside>
                    </div>
  
                    <!-- ==== END SIDEBAR === -->
                                
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- ======BG==== -->
        <div class="about__shape-wrap-four">
            <img src="assets/img/images/h4_about_shape01.png" alt="">
            <img src="assets/img/images/h4_about_shape02.png" alt="" data-parallax='{"x" : -80 , "y" : -80 }'>
        </div>


        <div class="modal fade" id="modalData" tabindex="-1" aria-labelledby="modalDataLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-scrollable">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="modalDataLabel">{{ modalData.judul }}</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Tutup"></button>
                </div>
                <div class="modal-body">
                    <blockquote>
                        <iframe :src="file_path+form.file" width="100%" height="860px"></iframe>
                    </blockquote>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Tutup</button>
                </div>
                </div>
            </div>
        </div>



        </section>
    </div>
</template>

<script>


export default {

    data() {
        return {
            unit_kerja: this.$store.state.UNIT_KERJA,
            data_load : false,
            
            id :'',
            file_path: this.$store.state.URL_APP + "uploads/",
            file_old: "",
            form : {
                id : '',                
                judul : '',
                sumber : '',
                deskripsi : '',
                uraian : '',
                foto : '',
                unit_kerja : '',
                status : '',
                keterangan : '',
                createAt : '',
            },

            list_data: [],
            page_first: 1,
            page_last: 0,
			cari_value: "",
              list_berita : [],

              modalData: {
            judul: '',
            deskripsi: ''
            },
            kategori:"RPJMN",
        }
    },

    mounted() {

        this.getView();
        this.getListBerita();

        },
    methods: {

        truncateText(text, limit = 50) {
            if (!text) return '';
            return text.length > limit ? text.substring(0, limit) + '...' : text;
        },
        
    getView: function() {
      fetch(this.$store.state.LAYANAN1 + "view", {
        method: "POST",
        headers: {
          "content-type": "application/json",
        },
        body: JSON.stringify({
          data_ke: this.page_first,
          cari_value: this.cari_value,
          judul: this.judul,
          kategori:this.kategori
        })
      })
        .then(res => res.json())
        .then(res_data => {
            this.list_data = res_data.data;
            this.page_last = res_data.jml_data;
        });
    },
    push_data(id) {
        const data = this.list_data.find(item => item.id === id);
        if (data) {
            this.modalData.judul = data.judul;
            this.modalData.deskripsi = data.deskripsi;
            this.form.file = data.file; // Tambahkan ini

            // Tampilkan modal Bootstrap 5
            // eslint-disable-next-line no-undef
            const modalEl = new bootstrap.Modal(document.getElementById('modalData'));
            modalEl.show();
        }
        },
    getListBerita: function() {
        this.cek_load_data_list = true;
        fetch(this.$store.state.ADD_URL_BERITA+"homeOPD", {
            method: "POST",
            headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
            },
                body: JSON.stringify({
                unit_kerja: this.unit_kerja,
                kategori_id: this.kategori_id
                
            })
        })
            .then(res => res.json())
            .then(res_data => {
                this.list_berita = res_data;
                // this.cek_load_data = false;
                // console.log(res_data);
        });
    },

    push_berita : function(id){
        this.$router.push('/isi_berita?id='+id);
    },

   
  // ================== PAGINASI ====================
  
    btn_prev : function(){
        if(this.page_first>1){
            this.page_first--
        }else{
            this.page_first = 1;
        }
        this.getView();
    },

    btn_next : function(){
        
        if(this.page_first >= this.page_last){
            this.page_first == this.page_last
        }else{
            this.page_first++;
        }
        this.getView();
    },

    cari_data : function(){

        this.page_first = 1;
        this.getView();
    },
  // ================== PAGINASI ====================
  convert_tgl: function(dateString) {
                    var date = new Date(dateString);
                    var getBulan = date.getMonth() + 1; var bulan = '';
                    if (getBulan == '1') {bulan = 'Jan'} 
                    else if(getBulan == '2') {bulan = 'Feb'}
                    else if(getBulan == '3') {bulan = 'Mar'}
                    else if(getBulan == '4') {bulan = 'Apr'}
                    else if(getBulan == '5') {bulan = 'Mei'}
                    else if(getBulan == '6') {bulan = 'Jun'}
                    else if(getBulan == '7') {bulan = 'Jul'}
                    else if(getBulan == '8') {bulan = 'Agt'}
                    else if(getBulan == '9') {bulan = 'Sep'}
                    else if(getBulan == '10') {bulan = 'Okt'}
                    else if(getBulan == '11') {bulan = 'Nov'}
                    else if(getBulan == '12') {bulan = 'Des'}



                    return date.getDate() + " " + bulan + " " + date.getFullYear();
                    // return bulan+ " " + date.getDate() + ". " + date.getFullYear();
                }
  },
  // =============================================================== METHODS =========================================================================

  
};
</script>
